import { Avatar, type AvatarProps } from '@mantine/core';
import { multiavatarDataUrl, type AvatarKind } from '@shared/avatar/multiavatar';
import { resolveMediaUrl, type MediaLocator } from '@domain/media/resolve';

type UserAvatarProps = AvatarProps & {
  id: number | string;
  name?: string | null;
  fallback?: string;
  avatarKind?: AvatarKind;
  avatarUrl?: string;
  media?: MediaLocator | null;
  cdnBase?: string;
};

export function UserAvatar({
  id,
  name,
  fallback,
  avatarKind = 'human',
  avatarUrl,
  media,
  cdnBase = 'http://localhost',
  radius = '50%',
  ...others
}: UserAvatarProps) {
  void fallback;
  const resolvedAvatarUrl = media
    ? resolveMediaUrl(media, cdnBase)
    : avatarUrl
      ? resolveMediaUrl({ provider: 's3', url: avatarUrl }, cdnBase)
      : '';

  return (
    <Avatar
      src={resolvedAvatarUrl || multiavatarDataUrl(id, avatarKind)}
      alt={name ?? String(id)}
      radius={radius}
      imageProps={{
        onError: (event: any) => {
          const fallbackSrc = multiavatarDataUrl(id, avatarKind);
          if (event.currentTarget.src !== fallbackSrc) {
            event.currentTarget.src = fallbackSrc;
          }
        }
      }}
      {...others}
    />
  );
}
